import { createStyles, Theme, withStyles, WithStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import DOMPurify from "dompurify";
import React from "react";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      whiteSpace: "pre-wrap",
      // Treat empty paragraphs as <br> tags
      "& p:empty::before": {
        content: '"\\00a0"',
      },
      "& > :first-child": {
        marginTop: 0,
      },
      "& > :last-child": {
        marginBottom: 0,
      },
      "& p": {
        margin: `${theme.spacing(1)}px 0`,
      },
      "& ol, & ul": {
        margin: `${theme.spacing(1)}px 0`,
        "& li": {
          marginBottom: theme.spacing(0.5),
        },
      },
    },
  });

interface HtmlContentProps extends WithStyles<typeof styles> {
  component: React.ElementType;
  children?: string | null;
  className?: string;
}

export const HtmlContentComponent = (props: HtmlContentProps) =>
  props.children != null ? (
    <props.component
      className={classNames(props.classes.root, props.className)}
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.children) }}
    />
  ) : null;

export const HtmlContent = withStyles(styles)(HtmlContentComponent);
